// Largest-remainder split of `target` units across the current allocations, keeping their proportions.
export function proportionalShares(quantities, target) {
  const total = quantities.reduce((sum, q) => sum + q, 0);
  const raw = quantities.map(q => (q * target) / total);
  const shares = raw.map(Math.floor);
  let left = target - shares.reduce((sum, q) => sum + q, 0);
  raw.map((value, index) => [value - Math.floor(value), index]).sort((a, b) => b[0] - a[0]).forEach(([, index]) => {
    if (left > 0) { shares[index] += 1; left -= 1; }
  });
  return shares;
}
